module.exports = __webpack_public_path__ + "static/media/iStock-927825486.15886cc6.jpg";